export default "__VITE_ASSET__BmAmJELY__"